import EmailVerification from 'app/models/email_verification';

import { setLocation } from 'utils/wrappers';
import { showSuccess, showResponseError } from 'utils/messages';

import Base from 'app/views/base';
import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {},

  initialize(options) {
    this.model = new EmailVerification({ id: options.code });
  },

  afterRender() {
    this.submit();
  },

  submit() {
    this.model.save({}, {
      success() {
        showSuccess('Success! Verification complete. You may now sign in.');
        setLocation('/signin');
      },
      error(model, response) {
        showResponseError(response);
      },
    });
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/verification_submit/index.js